import FootballState from "../../../../../sports/football/state/football-state";
import { TackleFragmentSerializer } from "./TackleFragmentSerializer";

export class PuntBlockedFragmentSerializer extends TackleFragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.PuntBlocked;
    }

    getRawFragment(play, serializationContext, puntBlocked) {
        return this.getRawFragmentForState(
            play,
            serializationContext,
            FootballState.PuntBlocked,
            puntBlocked
        );
    }
}
